import Vue from 'vue';
import EventHasVarieties from '../../../events/eventHasVarieties/EventHasVarieties';
import OrganiserAccordion from '../../../organiser/OrganiserAccordion/OrganiserAccordion';

export default {

  name: 'StepOne',

  components: {
    'event-has-varieties': EventHasVarieties,
    'organiser-accordion': OrganiserAccordion
  },

  inject: [
    'removeFromCart',
    'storageData',
    'stepValidation',
    'currentStep',
    'eventsData',
    'getEventByUuid'
  ],

  data () {
    return {
      totalCalculation: {},
      sumTotal: 0,
      resolvedPromises: 0,
      totalResolveEventHasVarietyPromises: 0,
      varietiesCheckFailed: false,
      OrganiserIsVisible: false
    };
  },

  watch: {
    totalCalculation: {
      handler: function (newValue) {
        let totalCount = 0;
        for (let k in this.totalCalculation) {
          totalCount = totalCount + this.totalCalculation[k].total;
        }
        this.sumTotal = totalCount;
      },
      deep: true
    }
  },

  // function definitions
  methods: {
    validateStep: function () {
      let proxy = this;
      this.totalResolveEventHasVarietyPromises = 0;
      this.resolvedPromises = 0;
      this.varietiesCheckFailed = false;
      Vue.set(this.stepValidation, 'isValid', false);
      Vue.set(this.stepValidation, 'triedToValidateStep', false);

      this.$refs.EventHasVariety.forEach(function (eventHasVar) {
        proxy.totalResolveEventHasVarietyPromises++;
        eventHasVar.$emit('updateVarietiesInCart');
        eventHasVar.addToCartPromise.then(function () {
          proxy.resolvePromise(eventHasVar);
        });
      });
    },
    resolvePromise: function (eventHasVar) {
      this.resolvedPromises++;
      if (eventHasVar.addToCartStatus.status === 'error') {
        this.varietiesCheckFailed = true;
      }
      if (this.resolvedPromises === this.totalResolveEventHasVarietyPromises) {
        if (!this.varietiesCheckFailed) {
          Vue.set(this.stepValidation, 'isValid', true);
          Vue.set(this.stepValidation, 'triedToValidateStep', false);
          this.$parent.currentStep = this.$parent.currentStep + 1;
        } else {
          Vue.set(this.stepValidation, 'triedToValidateStep', true);
        }
      }
    },
    varietiesUpdated: function (data) {
      if (data.hasOwnProperty('action')) {
        if (data.action == 'add') {
          Vue.set(this.totalCalculation, data.event.uuid, {
            event: data.event,
            total: data.total
          });
        } else if (data.action == 'remove') {
          Vue.delete(this.totalCalculation, data.event.uuid);
        }
      }
    }
  },

  created () {
    this.$parent.$off('validateCurrentStep').$on('validateCurrentStep', this.validateStep);
    this.$eventBus.$on('varietiesUpdated', this.varietiesUpdated);
  },

  mounted () {
    Vue.set(this.stepValidation, 'isValid', false);
  }

};



// WEBPACK FOOTER //
// ./src/apps/booking/components/bookingSteps/defaultSteps/1/StepOne.js